var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDismiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45694 9.09082C6.21584 9.09082 5.98461 9.1866 5.81412 9.35709C5.64363 9.52757 5.54785 9.75881 5.54785 9.99991C5.54785 10.241 5.64363 10.4722 5.81412 10.6427C5.98461 10.8132 6.21584 10.909 6.45694 10.909H13.7297C13.9708 10.909 14.202 10.8132 14.3725 10.6427C14.543 10.4722 14.6388 10.241 14.6388 9.99991C14.6388 9.75881 14.543 9.52757 14.3725 9.35709C14.202 9.1866 13.9708 9.09082 13.7297 9.09082H6.45694Z",
    fill: "#B54708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0938 10C20.0938 15.5227 15.6165 20 10.0938 20C4.57102 20 0.09375 15.5227 0.09375 10C0.09375 4.47727 4.57102 0 10.0938 0C15.6165 0 20.0938 4.47727 20.0938 10ZM18.2756 10C18.2756 11.0745 18.0639 12.1384 17.6528 13.131C17.2416 14.1237 16.6389 15.0257 15.8792 15.7854C15.1194 16.5452 14.2175 17.1478 13.2248 17.559C12.2321 17.9702 11.1682 18.1818 10.0938 18.1818C9.0193 18.1818 7.95537 17.9702 6.9627 17.559C5.97004 17.1478 5.06808 16.5452 4.30833 15.7854C3.54858 15.0257 2.94591 14.1237 2.53474 13.131C2.12356 12.1384 1.91193 11.0745 1.91193 10C1.91193 7.83005 2.77394 5.74897 4.30833 4.21458C5.84272 2.68019 7.9238 1.81818 10.0938 1.81818C12.2637 1.81818 14.3448 2.68019 15.8792 4.21458C17.4136 5.74897 18.2756 7.83005 18.2756 10Z",
    fill: "#B54708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDismiss);
export default __webpack_public_path__ + "static/media/dismiss.2f84ab613779d2c81c2f075b18bd2a0f.svg";
export { ForwardRef as ReactComponent };